import { cn } from "@/lib/utils";

export const Badge = ({ children, variant = "default", className, ...rest }) => {
  const styles = {
    default: "bg-[#E5E7EB] text-[#374151]",
    success: "bg-[#16A34A]/10 text-[#15803D]",
    warning: "bg-[#F59E0B]/10 text-[#B45309]",
    error: "bg-[#DC2626]/10 text-[#B91C1C]",
    info: "bg-[#0B3676]/10 text-[#0B3676]",
    accent: "bg-[#FFE600]/30 text-[#854D0E] border border-[#EAB308]/40",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold",
        styles[variant] || styles.default,
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
};

export const STATUS_LABELS = {
  // Quote
  draft: { label: "Taslak", variant: "default" },
  sent: { label: "Gönderildi", variant: "info" },
  approved: { label: "Onaylandı", variant: "success" },
  rejected: { label: "Onaylanmadı", variant: "error" },
  expired: { label: "Süresi Doldu", variant: "warning" },
  converted: { label: "Siparişe Dönüştü", variant: "accent" },
  cancelled: { label: "İptal", variant: "error" },
  revision_requested: { label: "Revizyon İstendi", variant: "warning" },
  // Order
  shipped: { label: "Sevk Edildi", variant: "info" },
  completed: { label: "Tamamlandı", variant: "success" },
  // Vade
  paid: { label: "Ödendi", variant: "success" },
  not_due: { label: "Vadesi Gelmedi", variant: "info" },
  due_today: { label: "Vadesi Bugün", variant: "warning" },
  overdue: { label: "Gecikmiş", variant: "error" },
  partial: { label: "Kısmi Ödendi", variant: "warning" },
  due_soon: { label: "Vade Yaklaşıyor", variant: "warning" },
  // Stock
  ok: { label: "Yeterli", variant: "success" },
  critical: { label: "Kritik", variant: "warning" },
  out: { label: "Stok Yok", variant: "error" },
};

export const StatusBadge = ({ status }) => {
  const def = STATUS_LABELS[status] || { label: status || "-", variant: "default" };
  return <Badge variant={def.variant}>{def.label}</Badge>;
};
